/* src/app/forms/wizard-configuracao/key-value-view/key-value-view.component.scss */
.panel-list-item-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 10px;
  background: white;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
  border: solid 1px #ccc;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
}
mat-form-field {
  width: 100%;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  font-weight: 300;
  text-align: center;
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.panel-list-item-form {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 4px;
  overflow: auto;
  gap: 10px;
}
.vertical-space {
  width: 100%;
  padding-bottom: 8px;
}
.keyvalue-properties-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
  gap: 10px;
}
.keyvalue-properties-content-keyvalue {
  background: white;
  position: absolute;
  top: -11px;
  background-color: white;
  font-weight: 500;
  font-size: small;
  padding-right: 10px;
  padding-left: 10px;
}
.keyvalue-properties-selection {
  width: 100%;
  flex-direction: row;
  display: flex;
  gap: 10px;
  align-items: center;
}
.chip-keyvalue-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
}
/*# sourceMappingURL=key-value-view.component.css.map */
